<template>
  <div class="emd-container _type_card" data-testid="container" v-if='shouldBuildPaymentDetails()'>
    <div class="emd-container__content">
      <div class="el-chunk">
        <h2>{{ $t(`${paymentMethod}.title`) }}</h2>
      </div>
      <p class="emd-text _size_small" v-if="paymentMethod === 'checkout'">
        {{ $t(`${paymentMethod}.subtitle`) }}
      </p>
      <div v-if="paymentMethod === 'credit_card'">
        <p class="emd-text _size_small">{{ card.holder_name.toUpperCase() }}</p>
        <p class="emd-text _size_small">{{ maskCreditCard(card.number) }}</p>
        <p class="emd-text _size_small">
          {{ creditCard.installments }}
          {{ $t("credit_card.installment")}}
          {{ installmentValue }}
        </p>
        <div class="emd-container__aside">
          <img alt="" :src="imageURL" />
        </div>
      </div>
      <div v-if="paymentMethod === 'checkout'">
        <p
          class="eu-ml_2 emd-text _size_small"
          v-if="checkout.accepted_payment_methods.includes('boleto')"
          data-testid="checkout-boleto-text"
        >
          {{ $t("checkout.accepted_payment_methods.boleto") }}
          {{ formatDate(checkout.boleto.due_at) }}
        </p>
        <p
          class="eu-ml_2 emd-text _size_small"
          v-if="checkout.accepted_payment_methods.includes('credit_card')"
          data-testid="checkout-credit-card-text"
        >
          {{ $t("checkout.accepted_payment_methods.credit_card") }}
        </p>
        <p
          class="eu-ml_2 emd-text _size_small"
          v-if="checkout.accepted_payment_methods.includes('pix')"
          data-testid="checkout-pix-text"
        >
          {{ $t("checkout.accepted_payment_methods.pix") }}
          {{ formatDate(checkout.pix.expires_at) }}
        </p>
      </div>
      <div v-if="paymentMethod === 'pix'">
        <p class="eu-ml_2 emd-text _size_small">
          {{ $t("pix.paymentDetails.expiresAt") }}
          {{ formatDate(pix.expires_at) }}
        </p>
      </div>
    </div>
    <div
      class="emd-container__content"
      v-if="isCreditCard() && getStatementDescriptor"
      data-testid="statement-descriptor"
    >
      <div class="el-chunk">
        {{ $t("statement_descriptor.payment_details") }}
      </div>
      <p class="emd-text _size_small">{{ getStatementDescriptor }}</p>
    </div>
    <div class="emd-container__content" data-testid="card-operation-type"  v-if="isCreditCard()">
      <div class="el-chunk">
        <h2 id="checkout-operation">{{ $t("credit_card.operation.label") }}</h2>
      </div>
      <p class="emd-text _size_small">
        {{ $t(`credit_card.operation.${buildCardOperation()}`) }}
      </p>
    </div>
  </div>
</template>

<script>
import { maskCreditCard, formatDate } from '@/utils/validations'
export default {
  name: 'PaymentDetails',
  props: {
    card: Object,
    checkout: Object,
    creditCard: Object,
    installmentValue: String,
    paymentMethod: String,
    imageUrl: String
  },
  methods: {
    maskCreditCard: maskCreditCard,
    formatDate: formatDate,
    isCreditCard () {
      return this.paymentMethod === 'credit_card' || this.checkout.accepted_payment_methods.includes('credit_card')
    },
    shouldBuildPaymentDetails () {
      return this.paymentMethod === 'credit_card' || this.paymentMethod === 'checkout' || this.paymentMethod === 'pix'
    },
    buildCardOperation () {
      return this.paymentMethod === 'checkout' ? this.checkout.credit_card.operation_type : this.card.operation
    }
  },
  computed: {
    pix () {
      return this.$store.getters.pix
    },
    getStatementDescriptor () {
      if (this.paymentMethod === 'credit_card') {
        return this.creditCard.statement_descriptor
      }
      return this.checkout.credit_card.statement_descriptor
    },
    imageURL () {
      return `${
        process.env.VUE_APP_CDN_URL
      }/assets/images/logos/brands/png/${this.card.label.toLowerCase()}.png`
    }
  }
}
</script>
